import { Component, OnInit, Injector, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AdministrationService } from '../administration.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { BannerService } from '../../ve.service';
import { AuthenticationService } from '../../../../auth.service';
import { AppService } from '../../../../app.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';

@Component({
  selector: 've-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BannerComponent implements OnInit {
  public fullScreenToggled = false;
  public bannerService: BannerService;
  public readonly adminService: AdministrationService;
  public readonly authService: AuthenticationService;
  private readonly appService: AppService;
  private readonly formBuilder: UntypedFormBuilder;
  private readonly _fullScreenToggled: any;
  dropdownList: any[];
  selectedDropdownValue: string;
  editForm: UntypedFormGroup;
  module: any;
  editorHeight = '435';

  constructor(
    public router: Router,
    protected injector: Injector,
    protected cgpSnackbarService: CgpSnackbarService,
    ) {
    this.formBuilder = injector.get(UntypedFormBuilder);
    this.adminService = injector.get(AdministrationService);
    this.bannerService = injector.get(BannerService);
    this.authService = injector.get(AuthenticationService);
    this.appService = injector.get(AppService);
    this.module = this.authService.getModule();
    this.read();

    this._fullScreenToggled = this.appService.fullScreenToggled.subscribe((isFullScreen) => {
      isFullScreen ? this.editorHeight = '540' : this.editorHeight = '435';
      this.fullScreenToggled = isFullScreen;
  });
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group(BannerEditForm);
    this.dropdownList = this.adminService.getDropdownList();
    this.selectedDropdownValue = this.adminService.getCurrentPageValue();
  }

  read = () => {
    this.bannerService.read(`/Module/${this.module}`)
    .then(bannerResult => this.editForm.reset(bannerResult));
  }

  save = () => {
    this.bannerService.save(this.editForm.value, false, `/${this.editForm.get('Id').value}`)
    .then(() => {
      this.showSnackbar('Banner Message was saved.');
    });
  }

  back = () => this.router.navigate(['/VE']);

  protected showSnackbar = (message: string) => {
    this.cgpSnackbarService.showSnackbar({
      message,
      duration: 5000,
    });
  }
}

const BannerEditForm = {
  Id: [],
  Message: [],
  ModuleId: []
};
